import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Card, Container, Stack } from '@mui/material';
import MessagesHeader from '@/components/Messages/MessagesHeader.tsx';
import MessagesList from '@/components/Messages/MessagesList.tsx';
import MessagesFooter from '@/components/Messages/MessagesFooter.tsx';

export const Route = createFileRoute(
  '/_manager/_app/collaborations/$id/messages',
)({
  component: Messages,
});

function Messages() {
  const { id } = Route.useParams();

  useEffect(() => {
    window.document.body.style.overflowY = 'hidden';
    return () => {
      window.document.body.style.overflowY = '';
    };
  }, []);

  return (
    <Container
      sx={{
        height: `calc(100vh - 50px)`,
        display: 'flex',
        flexDirection: 'column',
        py: {
          xs: 2,
          sm: 3,
        },
        my: {
          xs: -2,
          sm: -3,
        },
      }}>
      <Card
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
        }}
        variant="outlined">
        <Stack borderBottom={1} borderColor="divider" p={1}>
          <MessagesHeader creatorHasCampaignId={id} />
        </Stack>
        <MessagesList creatorHasCampaignId={id} />
        <Stack borderTop={1} borderColor="divider" p={1}>
          <MessagesFooter creatorHasCampaignId={id} />
        </Stack>
      </Card>
    </Container>
  );
}
